/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { AppBar, Button, Dialog, DialogActions, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Radio, Tab, Tabs, Typography } from '@material-ui/core';
import { DateRange } from '@material-ui/pickers';
import moment from 'moment/moment';
import { useStyles } from '../styles';
import { CheckIcon, CustomDialogTitle, DateRangeSelect, FieldLabel, InfoIcon, LightTooltip, RadioBtnCheckedIcon, WarningIcon } from '../../../../components';
import { CalculationPeriod, CalculationPeriodOptions, Campaign, EditCampaign, PeriodType } from '../../CashbackModel';
import { useCommonStyles } from '../../../../styles';
import { a11yProps } from '../../../../utils';

interface Props {
  partnerId: number;
  campaign: Campaign;
  translation: any;
  open: boolean;
  handleCancel: () => void;
  onSave: (campaign: EditCampaign) => void;
}

export const EditDefaultCampaignDialog: FC<Props> = ({ partnerId, campaign, translation, open, handleCancel, onSave }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const currentDate = useMemo(() => moment().toDate(), []);
  const [selectedDateRange, setSelectedDateRange] = React.useState<DateRange<Date>>([moment().toDate(), moment().toDate()]);
  const [periodType, setPeriodType] = useState<PeriodType>(PeriodType.Permanent);
  const [calculationPeriod, setCalculationPeriod] = useState<CalculationPeriod>(CalculationPeriod.Monthly);
  const [activeTab, setActiveTab] = useState<number>(2);

  useEffect(() => {
    setPeriodType(campaign.periodType === 'Permanent' ? PeriodType.Permanent : PeriodType.DateRange);
    setSelectedDateRange([campaign.startDate ? campaign.startDate : currentDate, campaign.endDate ? campaign.endDate : currentDate]);
    setCalculationPeriod(campaign.calculationPeriod === 'Daily' ? CalculationPeriod.Daily : campaign.calculationPeriod === 'Monthly' ? CalculationPeriod.Monthly : CalculationPeriod.Weekly);
  }, [campaign, currentDate]);

  const handleSave = (): void => {
    const newCampaign = {
      name: campaign.name || '',
      partnerId,
      periodType,
      startDate: periodType === PeriodType.Permanent ? null : selectedDateRange[0],
      endDate: periodType === PeriodType.Permanent ? null : selectedDateRange[1],
      calculationPeriod,
      clients: campaign.campaignClients.map((c) => c.clientLogin),
    };
    onSave(newCampaign);
  };

  const handleTabChange = useCallback((event: any, newValue: number) => {
    setActiveTab(newValue);
    setCalculationPeriod(CalculationPeriodOptions[newValue].value);
  }, []);

  return (
    <Dialog onClose={handleCancel} open={open} classes={{ paper: classes.dialog }} disableEnforceFocus>
      <CustomDialogTitle title={translation.edit_default_campaign} onClose={handleCancel} />
      <Grid container direction="column" alignItems="flex-start" className={commonClasses.dialogContent}>
        <Grid className={classes.warning}>
          <Grid container direction="row" alignItems="center" justify="space-between">
            <WarningIcon />
            <Grid item style={{ width: '90%', flexBasis: '90%' }}>
              <Typography className={classes.warningTitle}>{translation.attention}!</Typography>
              <Typography className={classes.warningText}>{translation.default_campaign_warning}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <FieldLabel label={translation.cashback_calculation_period} isRequired />
            <AppBar position="static" className={commonClasses.tabs}>
              <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
                {/* <Tab label={translation.text_1269} value={0} {...a11yProps(0)} /> */}
                {/* <Tab label={translation.weekly} value={1} {...a11yProps(1)} /> */}
                <Tab label={translation.text_1270} value={2} {...a11yProps(2)} />
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={12} className={classes.subTitleRow}>
            <p className={classes.subTitle}>{translation.timeframe}</p>
          </Grid>
          <Grid item xs={12} className={classes.margin}>
            <List dense>
              <ListItem key={PeriodType.DateRange}>
                <ListItemIcon>
                  <Radio checked={periodType === PeriodType.DateRange} checkedIcon={<RadioBtnCheckedIcon />} onChange={() => setPeriodType(PeriodType.DateRange)} />
                </ListItemIcon>
                <ListItemText>
                  <FieldLabel label={translation.campaign_active_period} isRequired>
                    <LightTooltip title={translation.campaign_active_period_tooltip} arrow placement="right-start">
                      <IconButton size="small" style={{ marginTop: '-10px' }}>
                        <InfoIcon className={classes.infoIcon} />
                      </IconButton>
                    </LightTooltip>
                  </FieldLabel>
                  <DateRangeSelect minDate={new Date()} defaultValue={selectedDateRange} onRangeChange={(value) => setSelectedDateRange(value)} />
                </ListItemText>
              </ListItem>
              <ListItem key={PeriodType.Permanent}>
                <ListItemIcon>
                  <Radio checked={periodType === PeriodType.Permanent} checkedIcon={<RadioBtnCheckedIcon />} onChange={() => setPeriodType(PeriodType.Permanent)} />
                </ListItemIcon>
                <ListItemText>{translation.campaign_period_permanent}</ListItemText>
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Grid>
      <DialogActions className={classes.dialogAction}>
        <Button onClick={handleSave} startIcon={<CheckIcon />} className={`${commonClasses.activeDialogBtn} ${classes.btn}`}>
          {translation.text_10}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
